import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsSearchBarComponent } from "./ds-search-bar.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";

@NgModule({
  declarations: [DsSearchBarComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsSearchBarComponent],
})
export class DsSearchBarModule {}
